import { FeatureBlock, FeatureComparison } from "../_copy-template"
import Analytics from "~images/pages/comparison/features/analytics.png"

export function getAnalyticsCopy(competitor: FeatureBlock): FeatureComparison {
    return {
        name: "Analytics",
        image: Analytics,
        chckup: {
            showCheck: true,
            description:
                "With Chckvet, if it's in your PIMS, you can track it. From snapshot reporting like our Daily Huddle to custom practice reporting with detailed drill-down ability, track practice performance & make decisions faster all in one place. Chckvet's analytics also track scheduling & client communications metrics like fill rate & reminder open rates.",
        },
        competitor,
        href: "/features/analytics",
    }
}
